(function(){
  var BM=window.BM||{};
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML}
  function money(c){
    var n=(c/100);
    function fmt(dec,th,de){var p=n.toFixed(dec).split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);return p.join(de)}
    return (BM.moneyFormat||'${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
      if(k==='amount_no_decimals')return fmt(0,',','.');
      if(k==='amount_with_comma_separator')return fmt(2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator')return fmt(0,'.',',');
      if(k==='amount_with_apostrophe_separator')return fmt(2,"'",'.');
      return fmt(2,',','.');
    });
  }
  /* ---------- cart api */
  function getCart(){return fetch(BM.routes.cart+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){return r.json()})}
  function post(url,body){
    return fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(d){if(!r.ok)throw new Error(d.description||d.message||'Something went wrong. Please try again.');return d})});
  }
  /* ---------- drawer */
  var drawer=$('#drawer'),scrim=$('#scrim'),last=null;
  function openC(){if(!drawer)return;last=document.activeElement;drawer.hidden=false;scrim.hidden=false;drawer.focus()}
  function closeC(){if(!drawer)return;drawer.hidden=true;scrim.hidden=true;if(last&&last.focus)last.focus()}
  function includedProtection(items){return items.some(function(i){return i.properties&&i.properties['Shipping Protection']==='Included'})}
  /* countdown: starts when the first item goes in, survives reloads, stops at zero */
  var TKEY='bm_reserve_until',tEnd=0;
  function st(k,v){try{if(v===undefined)return localStorage.getItem(k);if(v===null)localStorage.removeItem(k);else localStorage.setItem(k,v)}catch(e){return null}}
  function tick(){
    var el=$('#rsv');if(!el)return;
    var left=tEnd?Math.ceil((tEnd-Date.now())/1000):0;
    if(left<=0){el.hidden=true;return}
    el.hidden=false;var m=Math.floor(left/60),x=left%60;
    $('#rsvT').textContent=(m<10?'0':'')+m+':'+(x<10?'0':'')+x;
  }
  function syncTimer(count){
    if(!BM.timerMins)return;
    if(!count){tEnd=0;st(TKEY,null);tick();return}
    if(!tEnd){tEnd=+st(TKEY)||Date.now()+BM.timerMins*60000;st(TKEY,String(tEnd))}
    tick();
  }
  function renderCart(cart){
    var cnt=$('#count');if(cnt){cnt.hidden=!cart.item_count;cnt.textContent=cart.item_count}
    var dc=$('#dcount');if(dc){dc.hidden=!cart.item_count;dc.textContent=cart.item_count}
    syncTimer(cart.item_count);
    var lines=$('#lines'),foot=$('#foot');if(!lines)return;
    foot.hidden=!cart.items.length;
    if(!cart.items.length){lines.innerHTML='<div class="empty"><p>Your cart is empty</p><button type="button" class="btn" id="cs">Continue shopping</button></div>';$('#cs').onclick=closeC;return}
    var wasTotal=0;
    lines.innerHTML=cart.items.map(function(i){
      var was=(BM.compareAt&&BM.compareAt[i.variant_id])?BM.compareAt[i.variant_id]*i.quantity:0;
      var off=was>i.final_line_price?was-i.final_line_price:0;
      wasTotal+=off?was:i.final_line_price;
      var img=i.image?(i.image+(i.image.indexOf('?')>-1?'&':'?')+'width=160'):BM.fallbackImg;
      var props=Object.keys(i.properties||{}).filter(function(k){return k.charAt(0)!=='_'&&i.properties[k]}).map(function(k){return '<div class="props">'+esc(k)+': '+esc(i.properties[k])+'</div>'}).join('');
      return '<div class="ln"><img src="'+esc(img)+'" alt="" width="52" height="52" loading="lazy"><div style="min-width:0"><b>'+esc(i.product_title)+'</b>'+
        (i.variant_title&&i.variant_title!=='Default Title'?'<div class="props">'+esc(i.variant_title)+'</div>':'')+props+
        '<div class="row"><div class="qty"><button type="button" data-key="'+esc(i.key)+'" data-q="'+(i.quantity-1)+'" aria-label="Remove one">−</button><span>'+i.quantity+'</span><button type="button" data-key="'+esc(i.key)+'" data-q="'+(i.quantity+1)+'" aria-label="Add one">+</button></div>'+
        '<button type="button" class="trash" data-key="'+esc(i.key)+'" data-q="0" aria-label="Remove item"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9 3h6l1 2h4v2H4V5h4l1-2Zm-3 6h12l-1 12H7L6 9Z"/></svg></button></div></div>'+
        '<div class="am"><div class="pp">'+(off?'<s>'+money(was)+'</s>':'')+'<span>'+money(i.final_line_price)+'</span></div>'+(off?'<span class="off">SAVE '+money(off)+'</span>':'')+'</div></div>';
    }).join('');
    var w=$('#was');w.hidden=wasTotal<=cart.total_price;w.textContent=money(wasTotal);
    $('#items').textContent=cart.item_count+' '+(cart.item_count===1?'Item':'Items');
    $('#tot').textContent=money(cart.total_price);
    $('#fees').innerHTML=includedProtection(cart.items)?'<div class="rowt"><span>Shipping Protection</span><span>FREE</span></div>':'';
  }
  function refresh(){
    return getCart().then(function(cart){
      /* a paid protection line is dropped once a pack that includes it is in the cart */
      if(BM.protectionVariant&&includedProtection(cart.items)){
        var paid=cart.items.filter(function(i){return i.variant_id===BM.protectionVariant})[0];
        if(paid)return post(BM.routes.change+'.js',{id:paid.key,quantity:0}).then(function(c){renderCart(c);return c});
      }
      renderCart(cart);return cart;
    });
  }
  function bindDrawer(){
    if(!drawer)return;
    var oc=$('#openCart');if(oc)oc.addEventListener('click',function(){refresh();openC()});
    $('#closeCart').onclick=closeC;scrim.onclick=closeC;
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!drawer.hidden)closeC()});
    $('#lines').addEventListener('click',function(e){
      var b=e.target.closest('[data-key]');if(!b)return;
      post(BM.routes.change+'.js',{id:b.dataset.key,quantity:+b.dataset.q}).then(renderCart).catch(function(err){window.console&&console.error(err)});
    });
  }
  /* ---------- buy box */
  function bindBuy(){
    var form=$('#bm-form');if(!form)return;
    var err=$('#bm-err');
    function sync(){
      var sel=$('input[name=id]:checked',form);
      $$('.bun',form).forEach(function(l){l.classList.toggle('on',$('input',l).checked)});
      var p=$('#addP'),a=$('#pAmt');if(!p||!sel)return;
      var free=sel.dataset.free==='1';
      p.disabled=free;p.checked=free?true:p.dataset.user==='1';
      a.textContent=free?'FREE':a.dataset.price;a.classList.toggle('free',free);p.closest('.add').classList.toggle('free',free);
    }
    $$('input[name=id]',form).forEach(function(r){r.addEventListener('change',sync)});
    var pc=$('#addP');if(pc)pc.addEventListener('change',function(e){e.target.dataset.user=e.target.checked?'1':'0'});
    function add(e){
      if(e)e.preventDefault();
      var sel=$('input[name=id]:checked',form),btns=$$('[data-atc]');
      err.hidden=true;
      if(!sel||!sel.value){err.textContent='This store is still being set up. Connect a product in the theme settings.';err.hidden=false;return}
      var free=sel.dataset.free==='1';
      btns.forEach(function(b){b.disabled=true});
      getCart().then(function(cart){
        var inCart=function(id){return cart.items.some(function(i){return i.variant_id===id})};
        var line={id:+sel.value,quantity:+sel.dataset.qty||1};
        if(free)line.properties={'Shipping Protection':'Included'};
        var items=[line];
        var e1=$('#addE'),p1=$('#addP');
        if(p1&&!free&&p1.checked&&p1.dataset.id&&!inCart(+p1.dataset.id))items.push({id:+p1.dataset.id,quantity:1});
        if(e1&&e1.checked&&e1.dataset.id&&!inCart(+e1.dataset.id))items.push({id:+e1.dataset.id,quantity:1});
        return post(BM.routes.add+'.js',{items:items});
      }).then(refresh).then(openC).catch(function(x){err.textContent=x.message;err.hidden=false}).then(function(){btns.forEach(function(b){b.disabled=false})});
    }
    form.closest('form').addEventListener('submit',add);
    var a2=$('#atc2');if(a2)a2.addEventListener('click',add);
    sync();
    var bar=$('#bar'),atc=$('#atc');
    if(bar&&atc&&'IntersectionObserver' in window){
      new IntersectionObserver(function(en){var e=en[0],off=e.isIntersecting||e.boundingClientRect.top>0;if(off)bar.setAttribute('data-off','');else bar.removeAttribute('data-off');document.body.classList.toggle('has-bar',!off)}).observe(atc);
    }
  }
  /* ---------- gallery */
  function bindGallery(){
    var main=$('#mainImg'),th=$$('#thumbs button');if(!main||!th.length)return;
    var i=0;
    function show(n){i=(n+th.length)%th.length;main.src=th[i].dataset.full;main.alt=th[i].dataset.alt||'';th.forEach(function(b,x){b.setAttribute('aria-current',x===i?'true':'false')})}
    th.forEach(function(b,x){b.addEventListener('click',function(){show(x)})});
    var pr=$('#prev'),nx=$('#next');if(pr)pr.onclick=function(){show(i-1)};if(nx)nx.onclick=function(){show(i+1)};
    $$('[data-go]').forEach(function(b){b.addEventListener('click',function(){show((+b.dataset.go||1)-1);var g=$('.gal');g&&g.scrollIntoView({behavior:'smooth',block:'start'})})});
    th[0].setAttribute('aria-current','true');
  }
  /* ---------- small bits */
  function bindMisc(){
    var mb=$('#openMenu'),mn=$('#mnav');if(mb&&mn)mb.addEventListener('click',function(){mn.hidden=!mn.hidden;mb.setAttribute('aria-expanded',mn.hidden?'false':'true')});
    setInterval(tick,1000);
    $$('[data-pause]').forEach(function(btn){btn.addEventListener('click',function(){var s=btn.parentNode.querySelector('.strip');var p=s.classList.toggle('paused');btn.textContent=p?'▶ Play':'⏸ Pause'})});
    if(BM.snow&&!window.matchMedia('(prefers-reduced-motion:reduce)').matches){
      for(var i=0;i<14;i++){var s=document.createElement('span');s.className='flake';s.textContent='❄';s.setAttribute('aria-hidden','true');s.style.left=(i*7.3+Math.random()*5)+'%';s.style.fontSize=(9+Math.random()*7)+'px';s.style.animationDuration=(14+Math.random()*14)+'s';s.style.animationDelay=(-Math.random()*26)+'s';document.body.appendChild(s)}
    }
  }
  function init(){bindDrawer();bindBuy();bindGallery();bindMisc();if(drawer)refresh().catch(function(){})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){bindBuy();bindGallery()});
})();
